'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _reactiveContainer = require('reactive-container');

var _Month = require('./Month');

var _Month2 = _interopRequireDefault(_Month);

var _toRenderProps = require('../../../utils/toRenderProps');

var _toRenderProps2 = _interopRequireDefault(_toRenderProps);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MIN_CALENDAR_WIDTH = 344;

var BREAKPOINTS = [{ name: 'LG', minWidth: MIN_CALENDAR_WIDTH * 2 }];

var WithSize = (0, _toRenderProps2.default)(_reactiveContainer.withSize);

var Calendars = function (_Component) {
  _inherits(Calendars, _Component);

  function Calendars(props) {
    _classCallCheck(this, Calendars);

    var _this = _possibleConstructorReturn(this, (Calendars.__proto__ || Object.getPrototypeOf(Calendars)).call(this, props));

    _initialiseProps.call(_this);

    var range = props.range,
        selectedDate = props.selectedDate,
        selectedDateRange = props.selectedDateRange,
        initialVisibleDate = props.initialVisibleDate;


    var today = new Date();

    var visibleDate = initialVisibleDate || (range ? selectedDateRange.from : selectedDate) || today;

    var referenceMonth = (0, _utils.buildDisplayMonth)(visibleDate);

    _this.state = {
      displayMonthsArr: _this.buildDisplayMonthsArr(referenceMonth),
      hoveredOverDate: null,
      today: {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate()
      }
    };
    return _this;
  }

  _createClass(Calendars, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Clear the value of hoveredOverDate when a "to" selection is made
      if (this.props.range && nextProps.selectedDateRange.to && !this.props.selectedDateRange.to) {
        this.setState({ hoveredOverDate: null });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _styledComponentsReactiveGrid.ReactiveContainer,
        {
          breakpoints: BREAKPOINTS,
          className: 'CalendarsContainer',
          modifiers: ['fluid']
        },
        _react2.default.createElement(
          WithSize,
          null,
          this.buildMonths
        )
      );
    }
  }, {
    key: 'currentReferenceMonth',
    get: function get() {
      return this.state.displayMonthsArr[this.props.multiMonthDirection === 'future' ? 0 : 1];
    }

    /**
     * Builds an array of display months reflecting the months that may currently be displayed.
     */


    /**
     * Handles the navigation to earlier months.
     */


    /**
     * Handles the navigation to later months
     */


    /**
     * Handles updating the hoveredOverDate when the user moves the cursor
     * @param  {Date} date the date the cursor is currently hovered over
     */


    /**
     * Maps over the available displayMonths and returns the visible Months.
     */

  }]);

  return Calendars;
}(_react.Component);

Calendars.propTypes = {
  disabledDates: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date),
    before: _propTypes2.default.instanceOf(Date)
  }),
  multiMonth: _propTypes2.default.bool,
  multiMonthDirection: _propTypes2.default.oneOf(['past', 'future']),
  onSelectDate: _propTypes2.default.func.isRequired,
  range: _propTypes2.default.bool,
  selectedDate: _propTypes2.default.instanceOf(Date),
  selectedDateRange: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  initialVisibleDate: _propTypes2.default.instanceOf(Date)
};
Calendars.defaultProps = {
  disabledDates: {},
  multiMonth: false,
  multiMonthDirection: 'future',
  range: false,
  selectedDate: null,
  selectedDateRange: {},
  initialVisibleDate: null
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.buildDisplayMonthsArr = function (referenceMonth) {
    var _props = _this2.props,
        multiMonth = _props.multiMonth,
        multiMonthDirection = _props.multiMonthDirection;


    if (multiMonth) {
      var expandRight = multiMonthDirection === 'future';
      var monthOffset = expandRight ? 1 : -1;
      var otherMonth = (0, _utils.buildDisplayMonth)(referenceMonth, monthOffset);

      if (expandRight) {
        return [referenceMonth, otherMonth];
      }

      return [otherMonth, referenceMonth];
    }

    return [referenceMonth];
  };

  this.displayPreviousMonth = function () {
    var month = (0, _utils.buildDisplayMonth)(_this2.currentReferenceMonth, -1);

    _this2.setState({ displayMonthsArr: _this2.buildDisplayMonthsArr(month) });
  };

  this.displayNextMonth = function () {
    var month = (0, _utils.buildDisplayMonth)(_this2.currentReferenceMonth, 1);

    _this2.setState({ displayMonthsArr: _this2.buildDisplayMonthsArr(month) });
  };

  this.updateHoveredOverDate = function (date) {
    if (_this2.props.range && !_this2.props.selectedDateRange.to) {
      _this2.setState({ hoveredOverDate: date });
    }
  };

  this.buildMonths = function (_ref) {
    var size = _ref.size;

    var isSmall = size === 'XS';
    var hiddenIndex = _this2.props.multiMonthDirection === 'future' ? 1 : 0;

    var finalMonths = isSmall ? _this2.state.displayMonthsArr.filter(function (_, i) {
      return i !== hiddenIndex;
    }) : _this2.state.displayMonthsArr;

    return _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { style: { flexWrap: 'nowrap' } },
      finalMonths.map(function (displayMonth, index) {
        return _react2.default.createElement(_Month2.default, {
          key: displayMonth.month,
          disabledDates: _this2.props.disabledDates,
          displayMonth: displayMonth,
          displayNextNav: index === finalMonths.length - 1,
          displayPreviousNav: index === 0,
          hoveredOverDate: _this2.state.hoveredOverDate,
          onClickNext: _this2.displayNextMonth,
          onClickPrevious: _this2.displayPreviousMonth,
          onSelectDate: _this2.props.onSelectDate,
          range: _this2.props.range,
          selectedDate: _this2.props.selectedDate,
          selectedDateRange: _this2.props.selectedDateRange,
          today: _this2.state.today,
          updateHoveredOverDate: _this2.updateHoveredOverDate
        });
      })
    );
  };
};

Calendars.displayName = 'Calendars';

exports.default = Calendars;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/DateSelectors/Calendars/index.js
// module id = 724
// module chunks = 2